module.exports = __webpack_public_path__ + "img/intro_mo_img01.4ab2f9c8.png";